module.exports = __webpack_public_path__ + "img/電気回路_3_4_1.9110f109.png";